import { Scale } from "../../../utils/Scale"

export class MenPos {
    static titleY = () => Scale.height() * 0.04

    static scientistX = () => Scale.width() * 0.65
    static scientistY = () => Scale.height() * 0.05

    static rugX = () => Scale.width() * 0.02
    static rugY = () => Scale.height() * 0.6

    static dogX = () => Scale.width() * 0.08
    static dogY = () => Scale.height() * 0.17

    static dogTailX = () => MenPos.dogX() - Scale.width() * 0.04
    static dogTailY = () => MenPos.dogY() + Scale.height() * 0.48

    static droolX = () => MenPos.dogX() + Scale.width() * 0.327
    static droolY = () => MenPos.dogY() + Scale.height() * 0.153

    static pavlovX = () => Scale.width() * 0.59
    static pavlovY = () => Scale.height() * 0.12

    static bellX = () => Scale.width() * 0.63
    static bellY = () => Scale.height() * 0.05

    static thoughtX = () => Scale.width() * 0.45
    static thoughtY = () => Scale.height() * 0.15

    static foodDishX2 = () => Scale.width() * 0.6
    static foodDishX = () => Scale.width()
    static foodDishY = () => Scale.height() * 0.6

    static projectorX = () => Scale.width() * 1.02
    static projectorY = () => Scale.height() * 0.1

    static coffeeSceneX = () => Scale.width() * 1.04
    static coffeeSceneY = () => Scale.height() * 0.07
    static coffeeSceneY2 = () => Scale.height() * 0.25

    static coffeeSmellX = () => Scale.width() * 1.377
    static coffeeSmellY = () => Scale.height() * 0.55

    static coffeeX = () => Scale.width() * 0.66
    static coffeeX2 = () => Scale.width() * 0.9
    static coffeeY = () => Scale.height() * 0.26

    static ecigX = () => Scale.width() * 1.6
    static ecigX2 = () => Scale.width() * 1.12
    static ecigY = () => Scale.height() * 0.15

    static thoughtEcigX = () => Scale.width() * 1.23
    static thoughtEcigY = () => Scale.height() * 0.16

}
